import { call, put, takeLatest } from "redux-saga/effects";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { callAPI, handleError, handleSuccess } from "../api/api";

import store from "../store";
import { addFeedbackAction, getAllFeedbackListAction, getAskFeedbackAction, getSingleLeadCompletionNotesAction, getSingleLeadFeedbackAction, setAddFeedbackResponse, setAllFeedbackListAction, setAskFeedbackResponse, setSingleLeadCompletionNotesResponse, setSingleLeadFeedbackResponse, setUpdatedCompletedFeedbackResponse, setUpdateFeedbackResponse, updatedCompletedFeedbackAction, updateFeedbackAction } from "../reducers/feedbackSlice";
import { getAllLeadListAction } from "../reducers/leadSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllFeedbackListSaga():any {
    yield put(setLoaderAction(true))

    try {
      
        const res = yield call<any>(callAPI, {}, 'get', `client/feedback-questions`)
    
        if (res?.data) {
            yield put(setAllFeedbackListAction(res?.data))
        }
    } catch (error:any) {
       
        error?.response && handleError(error?.response, [401]);
        error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setLoaderAction(false))  
} 

function* addFeedbackSaga(payload: any[]):any {
    yield put(setLoaderAction(true))
    try {
    
        const apiResponse = yield call<any>(callAPI, payload, 'post', 'client/feedback-questions')
     
        if (apiResponse?.success === true) {
            apiResponse && handleSuccess(apiResponse);
            yield put(setAddFeedbackResponse(true));
        }
    } catch (error: any) {
 
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setAddFeedbackResponse(false));
    }
    yield put(setLoaderAction(false))
}

function* updateFeedbackSaga(payload: any[]):any {
    yield put(setLoaderAction(true))
    try {
   
        const apiResponse = yield call<any>(callAPI, payload, 'post', 'client/feedback-questions')
      
        if (apiResponse?.success === true) {
            yield put(setUpdateFeedbackResponse(true));
        }
    } catch (error: any) {
     
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setUpdateFeedbackResponse(false));
    }
    yield put(setLoaderAction(false))
}

function* getSingleLeadFeedbackSaga(payload: { payload: any }): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: "error" }));
    try {
  
      const  leadId  = payload?.payload
      const apiResponse = yield call<any>(callAPI, null, "get", `leads/${leadId}/feedback`);
   
      if (apiResponse?.success === true) {
        // apiResponse && handleSuccess(apiResponse);
        yield put(setSingleLeadFeedbackResponse(apiResponse?.data))
      }
    } catch (error: any) {
    
    //   error?.response && handleError(error?.response);
      yield put(setSingleLeadFeedbackResponse(false));
      //   yield put(setAdminErrorAction(true));
    }
    yield put(setLoaderAction(false));
  }

  function* getSingleLeadCompletionNotesSaga(payload: { payload: any }): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: "error" }));
    try {
        
      const  leadId  = payload?.payload
      const apiResponse = yield call<any>(callAPI, null, "get", `leads/${leadId}/notes?action=ALL`);
  
      if (apiResponse?.success === true) {
        // apiResponse && handleSuccess(apiResponse);
        yield put(setSingleLeadCompletionNotesResponse(apiResponse?.data))
      }
    } catch (error: any) {
     
    //   error?.response && handleError(error?.response);
    //   yield put(setSingleLeadFeedbackResponse(false));
      //   yield put(setAdminErrorAction(true));
    }
    yield put(setLoaderAction(false));
  }

  function* getAskFeedbackSaga(payload: { payload: any }): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: "error" }));
    try {
  
      const  leadId  = payload?.payload
      const apiResponse = yield call<any>(callAPI, null, "post", `leads/${leadId}/feedback`);
   
      if (apiResponse?.success === true) {
        apiResponse && handleSuccess(apiResponse);
        yield put(setAskFeedbackResponse(true));
      }
    } catch (error: any) {
   
      error?.response && handleError(error?.response);
      error?.code === "ERR_NETWORK" && handleError(error);
      yield put(setAskFeedbackResponse(false));
      //   yield put(setAdminErrorAction(true));
    }
    yield put(setLoaderAction(false));
  }

  function* updatedCompletedFeedbackSaga(payload: { payload: any }): any {
    yield put(setLoaderAction(true));
    yield put(setNotificationAction({ message: [], severity: "error" }));
    try {
    
      const apiResponse = yield call<any>(callAPI, payload, "post", `leads/change-status`);

      if (apiResponse?.success === true) {
        apiResponse && handleSuccess(apiResponse);
        yield put(setUpdatedCompletedFeedbackResponse(true));
        yield put(
          getAllLeadListAction({
            page: 1,
            limit: 10,
            orderBy: "created_at",
            orderIn: "DESC",
            search: "",
            roleType:"Admin"
          })
        );
      }
    } catch (error: any) {
  
      error?.response && handleError(error?.response);
      error?.code === "ERR_NETWORK" && handleError(error);
      yield put(setUpdatedCompletedFeedbackResponse(false));
      //   yield put(setAdminErrorAction(true));
    }
    yield put(setLoaderAction(false));
  }

export function* watchFeedback() {
    yield takeLatest<any>(getAllFeedbackListAction, getAllFeedbackListSaga);
    yield takeLatest<any>(addFeedbackAction, addFeedbackSaga);
    yield takeLatest<any>(updateFeedbackAction, updateFeedbackSaga);
    yield takeLatest<any>(getSingleLeadFeedbackAction,getSingleLeadFeedbackSaga );
    yield takeLatest<any>(getSingleLeadCompletionNotesAction,getSingleLeadCompletionNotesSaga);
    yield takeLatest<any>(getAskFeedbackAction,getAskFeedbackSaga);
    yield takeLatest<any>(updatedCompletedFeedbackAction, updatedCompletedFeedbackSaga);

}